<template>
  <h1 :class="breadcrumbClass">
    <nuxt-link v-if="displayHome" to="/" class="breadcrumb-item hover-transition">
      {{ $t('page.common.home') }}
    </nuxt-link>
    <div v-if="displayHome">
      <span v-if="separateSymbol" class="breadcrumb-separator">{{ separateSymbol }}</span>
      <span v-else class="breadcrumb-separator-arrow">{{ separateSymbol }}</span>
    </div>

    <nuxt-link v-if="categoryName" class="breadcrumb-item hover-transition" :to="categoryPath">
      {{ categoryName }}
    </nuxt-link>
    <div v-if="categoryName">
      <span v-if="separateSymbol" class="breadcrumb-separator">{{ separateSymbol }}</span>
      <span v-else class="breadcrumb-separator-arrow">{{ separateSymbol }}</span>
    </div>
    <nuxt-link v-if="subCategoryName" class="breadcrumb-item hover-transition" :to="subCategoryPath">
      {{ subCategoryName }}
    </nuxt-link>
    <div v-if="subCategoryName">
      <span v-if="separateSymbol" class="breadcrumb-separator">{{ separateSymbol }}</span>
      <span v-else class="breadcrumb-separator-arrow">{{ separateSymbol }}</span>
    </div>
    <span v-if="title" class="breadcrumb-title text-overflow-ellipsis" :title="title">{{ title }}</span>
  </h1>
</template>
<script>
export default {
  props: {
    // 类名
    breadcrumbClass: {
      type: String,
      default: 'breadcrumb',
      required: false,
    },
    // 隐藏、显示首页链接
    displayHome: {
      type: Boolean,
      default: false,
      required: false,
    },
    // 二级页类目名称
    categoryName: {
      type: String,
      default: '',
      required: false,
    },
    // 二级页类目路径
    categoryPath: {
      type: String,
      default: '',
      required: false,
    },
    // 三级目录路径
    subCategoryName: {
      type: String,
      default: '',
      required: false,
    },
    // 三级页类目路径
    subCategoryPath: {
      type: String,
      default: '',
      required: false,
    },
    // 详情页标题
    title: {
      type: String,
      default: '',
      required: false,
    },
    // 分隔符
    separateSymbol: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {

  },
}
</script>
